<template>
  <CustomPage title="售后中心" style="background: #f7f7f7">
    <div slot="content" style="height: 100%">
      <div class="order-container">
        <div class="tabs overflow-x-auto">
          <div
            class="tab text-xs"
            style="white-space: nowrap"
            :class="{ active: active === item.value }"
            v-for="item in tabs"
            :key="item.value"
            @click="tabClick(item.value)"
          >
            <span>{{ item.name }}</span>
          </div>
        </div>

        <van-search
          v-model.trim="searchValue"
          show-action
          placeholder="请输入订单的编号或手机号或收件人"
        >
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
        <div class="list">
          <AftSale ref="AftSale" :tabType="active" :searchValue="searchValue" />
        </div>
      </div>
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from "@/components/custom-page.vue";
import CustomView from "@/components/custom-view.vue";
import AftSale from "./components/AftSale";
export default {
  components: { CustomPage, CustomView, AftSale },
  data() {
    return {
      active: 0,
      tabs: [
        { name: "全部", value: 0 },
        { name: "待审核", value: "INITIAL" },
        { name: "待填写物流信息", value: "SUPPLIER_APPROVED" },
        { name: "待商家收货", value: "SHIPPED" },
        { name: "待退款", value: "CONFIRMED" },
        { name: "已完成", value: "COMPLETED" },
        { name: "拒绝收货", value: "SHIPPED_REJECTED" },
        { name: "拒绝退款", value: "REFUSED_REFUND" },
        { name: "已作废", value: "INVALID" },
      ],

      searchValue: "",
    };
  },
  created() {
    if (this.$route.query.hasOwnProperty("active")) {
      this.active = Number(this.$route.query.active);
    }
  },

  methods: {
    tabClick(val) {
      // 每次tab 点击 都清空搜索值
      this.searchValue = "";
      this.active = val;
      this.$nextTick(() => {
        this.$refs.AftSale.tabTypeChange();
      });
    },

    // 搜索框搜索
    onSearch() {
      this.$nextTick(() => {
        this.$refs.AftSale.tabTypeChange();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.order-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  .tabs {
    display: flex;
    padding: 22px 0 20px;
    background: #fff;
    .tab {
      flex: auto;
      text-align: center;
      span {
        display: inline-block;
        padding: 8px 28px;
        font-size: 24px;
        color: #666;
        line-height: 24px;
      }
      &.active span {
        color: #fff;
        background: #e82035;
        border-radius: 40px;
      }
    }
  }
  .list {
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }
}
</style>
